import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { FiBarChart2, FiClipboard, FiFileText, FiLogOut, FiMenu, FiUsers, FiX } from 'react-icons/fi';
import { useControlAuth } from '../ControlAuthContext';
import './ControlLayout.css';

const ALL_TABS = [
  { path: '/control', label: 'Overview', icon: FiBarChart2, end: true },
  { path: '/control/orders-control', label: 'Orders', icon: FiClipboard },
  { path: '/control/pending-quotes', label: 'Pending Quotes', icon: FiFileText },
  { path: '/control/user-control', label: 'Team', icon: FiUsers, adminOnly: true },
];

const ControlLayout = ({ children }) => {
  const { user, logout } = useControlAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => setMenuOpen(false), [location.pathname]);
  if (!user) return null;

  const tabs = ALL_TABS.filter((tab) => !tab.adminOnly || user.accesstype === 0);
  const initials = String(user.name || user.userid || 'C').split(/\s+/).slice(0, 2)
    .map((part) => part[0]).join('').toUpperCase();
  const handleLogout = () => {
    logout();
    navigate('/control-login', { replace: true });
  };

  return (
    <div className="control-shell">
      <header className="control-mobile-header">
        <div><span className="control-brand-mark">V</span><strong>Valley Control</strong></div>
        <button type="button" onClick={() => setMenuOpen((open) => !open)} aria-label={menuOpen ? 'Close menu' : 'Open menu'}>{menuOpen ? <FiX /> : <FiMenu />}</button>
      </header>
      <aside className={`control-sidebar ${menuOpen ? 'is-open' : ''}`}>
        <div className="control-brand"><span className="control-brand-mark">V</span><div><strong>Valley Control</strong><span>Operations workspace</span></div></div>
        <nav className="control-tabs" aria-label="Control panel sections">
          <span className="control-tabs-label">Workspace</span>
          {tabs.map(({ path, label, icon: Icon, end }) => (
            <NavLink key={path} to={path} end={end} className={({ isActive }) => `control-tab ${isActive ? 'is-active' : ''}`}><Icon /><span>{label}</span></NavLink>
          ))}
        </nav>
        <div className="control-account">
          <span className="control-account-avatar">{initials}</span>
          <div><strong>{user.name || user.userid}</strong><span>{user.accesstype === 0 ? 'Administrator' : 'Sales representative'}</span></div>
          <button type="button" onClick={handleLogout} title="Log out" aria-label="Log out"><FiLogOut /></button>
        </div>
      </aside>
      {menuOpen && <button className="control-menu-backdrop" type="button" aria-label="Close menu" onClick={() => setMenuOpen(false)} />}
      <main className="control-content">{children}</main>
    </div>
  );
};

export default ControlLayout;
